import { clamp01, easeOutCubic } from "./easing.js";

export const FAILED_CROSS_COLOR = "#cf3548";
export const FAILED_CROSS_WEIGHT = 1.45;

// Coordinates are relative to a 100×100 tile, centered at the origin.
// Each brush follows a curved spine with pressure and a slightly dry edge.
export const BRUSH_CURVES = [
  [
    [-23, -25],
    [-18, -5],
    [12, 16],
    [25, 22],
  ],
  [
    [25, -25],
    [15, -12],
    [-14, 18],
    [-24, 25],
  ],
];
export function brushPolygon(stroke, progress, seed = 0, weight = 1) {
  const limit = clamp01(progress);
  if (limit <= 0) return [];
  const points = BRUSH_CURVES[stroke];
  const left = [],
    right = [];
  const samples = Math.max(3, Math.ceil(30 * limit));
  for (let i = 0; i <= samples; i += 1) {
    const t = (limit * i) / samples,
      u = 1 - t;
    const x =
      u ** 3 * points[0][0] +
      3 * u ** 2 * t * points[1][0] +
      3 * u * t ** 2 * points[2][0] +
      t ** 3 * points[3][0];
    const y =
      u ** 3 * points[0][1] +
      3 * u ** 2 * t * points[1][1] +
      3 * u * t ** 2 * points[2][1] +
      t ** 3 * points[3][1];
    const dx =
      3 * u ** 2 * (points[1][0] - points[0][0]) +
      6 * u * t * (points[2][0] - points[1][0]) +
      3 * t ** 2 * (points[3][0] - points[2][0]);
    const dy =
      3 * u ** 2 * (points[1][1] - points[0][1]) +
      6 * u * t * (points[2][1] - points[1][1]) +
      3 * t ** 2 * (points[3][1] - points[2][1]);
    const length = Math.hypot(dx, dy) || 1;
    const pressure = 1.35 + 2.3 * Math.sin(Math.PI * t) ** 0.65;
    const edge =
      Math.sin(t * 81 + seed * 5 + stroke * 3) * 0.22 +
      Math.cos(t * 47 + seed) * 0.13;
    const leading = Math.min(1, (limit - t) * 28 + 0.3);
    const width = Math.max(0.4, (pressure + edge) * leading) * weight;
    left.push([x - (dy / length) * width, y + (dx / length) * width]);
    right.push([
      x + (dy / length) * (width * 0.87),
      y - (dx / length) * (width * 0.87),
    ]);
  }
  return [...left, ...right.reverse()].flat();
}
export function crossStrokeProgress(progress) {
  return [
    easeOutCubic(clamp01(progress / 0.51)),
    easeOutCubic(clamp01((progress - 0.43) / 0.57)),
  ];
}
export function brushCrossSvg(id, auto = false, failed = false) {
  const paths = BRUSH_CURVES.map((curve, stroke) => {
    const center = `M${curve[0].join(",")}C${curve.slice(1).flat().join(",")}`;
    const polygon = brushPolygon(stroke, 1, id.length % 3, failed ? FAILED_CROSS_WEIGHT : 1).join(",");
    return `<defs><mask id="${id}-${stroke}" maskUnits="userSpaceOnUse" x="-50" y="-50" width="100" height="100"><path d="${center}" pathLength="100" class="brush-reveal brush-${stroke}" fill="none" stroke="white" stroke-width="16" stroke-linecap="round"/></mask></defs><polygon points="${polygon}" fill="${failed ? FAILED_CROSS_COLOR : "#fffaf1"}" mask="url(#${id}-${stroke})"/>`;
  }).join("");
  return `<svg class="mark brush-cross ${failed ? "failed-mark" : auto ? "auto-mark" : "manual-mark"}" viewBox="-50 -50 100 100" aria-hidden="true">${paths}</svg>`;
}
